module.exports = __webpack_public_path__ + "static/media/pwc.f60e9314.jpg";